import { createFileRoute } from '@tanstack/react-router'
import PageEntrance from '~components/motion/page-entrance'
import Agreement from '~containers/app/ask-a-vet/1_agreement'
import { resetConsultationData } from '~containers/app/ask-a-vet/store/consultation-data'

export const Route = createFileRoute('/samsung/smart-things/(app)/ask-a-vet/agreement')({
  component: RouteComponent,
  beforeLoad: async () => {
    resetConsultationData()
  },
})

function RouteComponent() {
  return (
    <PageEntrance>
      <Agreement />
    </PageEntrance>
  )
}
